/**
 * InfoOnboarding — content for the Info mode onboarding panel.
 *
 * Pure presentational component: renders the title, body and dismiss button.
 * Visibility and sessionStorage persistence are handled by OnboardingContext /
 * OnboardingOverlay — this component only needs to call closeOnboarding() on dismiss.
 */
import { useState } from 'react'

import { useProduct } from '../../index.js'

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { COLOR_SCHEME_REGISTRY, COLOR_SCHEME_ORDER } from '../../constants/colorSchemes.js'

import { InfoMode }  from '../../../../shared/ui/icons/index.js'

import styles from './InfoOnboarding.module.scss'
import pane_styles from './OnboardingOverlay.module.scss' // for shared styles like .title

export function InfoOnboarding({isMobile, loadExpanded = false}) {
  const { t } = useI18n()

  const { capabilities } = useProduct()
  const { availableColorSchemes } = capabilities

  const [expanded, setExpanded] = useState(loadExpanded)

  const schemeOptions = COLOR_SCHEME_ORDER
    .filter((s) => availableColorSchemes.includes(s))
    .map((s) => ({ label: t(COLOR_SCHEME_REGISTRY[s].labelKey), desc: t(`product.${s}_desc`) }))

  const ctaMessage = isMobile 
    ? t('product.info_onboarding_cta_mobile') 
    : t('product.info_onboarding_cta_desktop');

  return (
    <div className={pane_styles.content}>
      <span className={pane_styles.title}><InfoMode />{t('product.info_onboarding_title')}</span>
      {expanded && <p className={pane_styles.body}>{t('product.info_onboarding_par1')}</p>}
      {schemeOptions.length > 1 && (
        <>
          <p className={pane_styles.cta}>{ctaMessage}</p>
          {expanded && <p className={styles.schemeList}> {
            schemeOptions.map((s, index) => (
              <span key={s.label}>
                {`- `}<strong>{s.label}</strong>{`: ${s.desc}`}
                {index < schemeOptions.length - 1 && <br />}
              </span>
            ))
          }.</p>}
        </>
      )}
    <span
      className={pane_styles.cta}
      onClick={() => setExpanded((e) => !e)}
      style={{ cursor: 'pointer' }}
    >
      {expanded ? t('product.onboarding_hide_details') : t('product.onboarding_learn_more')}
    </span>
    </div>
  )
}


    // "info_onboarding_compartment_popover": "Najeźdź na pomieszczenie, aby zobaczyć szczegóły: {{dataItems}}",
    // "info_onboarding_equipment_popover": "Najeźdź na wyposażenie, aby zobaczyć nawę i wymiary.",
    // "info_onboarding_openings_popover": "Najeźdź na okna, aby zobaczyć szczegóły: {{dataItems}}",
    // "info_onboarding_walls_popover": "Najeźdź na ściany działowe, aby zobaczyć ich powierzchnię.",